import { render } from "./PayableParticipations.vue?vue&type=template&id=c89d213c"
import script from "./PayableParticipations.vue?vue&type=script&lang=js"
export * from "./PayableParticipations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__